import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Banner from '../components/Banner'

import pic01 from '../assets/images/team-grow.jpeg'
import pic02 from '../assets/images/Dany.png'
import pic03 from '../assets/images/startup.jpg'
import pic04 from '../assets/images/pic04.jpg'
import pic05 from '../assets/images/pic05.jpg'
import pic06 from '../assets/images/pic06.jpg'
import portrait from '../assets/images/dany_cut.png'
import { TechCloud } from '../components/TechCloud'

class HomeIndex extends React.Component {
  render() {
    return (
      <Layout>
        <Helmet
          title="Ardevia Software GmbH"
          meta={[
            {
              name: 'description',
              content: 'Home site of Ardevia Software GmbH',
            },
            {
              name: 'keywords',
              content:
                'ardevia, software, startups, development, software, nearshoring',
            },
          ]}
        ></Helmet>

        <Banner />

        <div id="main">
          <section id="one" className="tiles">
            <article style={{ backgroundImage: `url(${pic02})` }}>
              <header className="major">
                <h3>Who is Ardevia?</h3>
                <p>Knowledge, experience and a network...</p>
              </header>
              <Link to="/#who" className="link primary"></Link>
            </article>
            <article style={{ backgroundImage: `url(${pic01})` }}>
              <header className="major">
                <h3>What we do?</h3>
                <p>
                  Maximize your chances of developing a successful product...
                </p>
              </header>
              <Link to="/#what" className="link primary"></Link>
            </article>
            {/*<article style={{backgroundImage: `url(${pic03})`}}>
                            <header className="major">
                                <h3>How do we do it?</h3>
                                <p>
                                    There is no one right way. It depends on the environment, the people, your values, etc.
                                    But trust us to guide and support you through the following areas:
                                    <ul>
                                        <li>processes</li>
                                        <li>infrastructure & tooling</li>
                                        <li>architecture, technology and concepts</li>
                                    </ul>
                                </p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic04})`}}>
                            <header className="major">
                                <h3>Ipsum</h3>
                                <p>Nisl sed aliquam</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic05})`}}>
                            <header className="major">
                                <h3>Consequat</h3>
                                <p>Ipsum dolor sit amet</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic06})`}}>
                            <header className="major">
                                <h3>Etiam</h3>
                                <p>Feugiat amet tempus</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                </article>*/}
          </section>
          <section id="who">
            <div className="inner">
              <header className="major">
                <h2>Who is Ardevia?</h2>
              </header>
              <div className="who-content">
                <img
                  src={portrait}
                  style={{
                    height: '150px',
                    marginTop: '4px',
                    marginBottom: '32px',
                    marginRight: '20px',
                    borderRadius: '12px',
                    opacity: 0.95,
                  }}
                  alt="Ardevia"
                />
                <p>
                  Ardevia is owned and led by Dany Wyss.
                  <br />
                  For over 25 years he has repeatedly led and guided companies
                  and product teams from ideas to successful implementation of
                  innovative software products. As a software engineer with
                  strong technical expertise and wide experience from management
                  to product strategies down to programming bits and bytes, he
                  knows how to create, support and nurture software development
                  teams to excel in creating software products fit for the
                  market.
                  <br />
                  He is backed by a network of first-class Swiss and nearshore
                  developers and other leading experts where needed.
                </p>
              </div>
              <ul className="actions">
                <li>
                  <Link to="#contact" className="button next">
                    Get in touch
                  </Link>
                </li>
              </ul>
            </div>
          </section>
          <section id="what">
            <div className="inner">
              <header className="major">
                <h2>What we do?</h2>
              </header>
              <p>
                As a startup, spin-off or other new software product iniative
                you need to get your first results off the ground quickly,
                efficiently. But you also want to build up your development in a
                way that optimally increases your chances to succeed. Not many
                enterpreneurs have the experience or network to do this on their
                own.
              </p>
              <p>
                We make this happen with state-of-the-art technologies, tools
                and processes. And we do it better, because we've done it before
                and know what works and what not.
              </p>
              <p>
                Of course there is no one right way. This is where our wisdom
                helps assess the environment, the people involved, your values,
                etc. and find the optimal match specific to your software
                development:
                <ul>
                  <li>development strategy and processes</li>
                  <li>infrastructure, resources & tooling</li>
                  <li>architecture, technology and concepts</li>
                </ul>
              </p>
              <p>
                And where needed we can extend your team using nearshoring, so that 
                you can extend and accelerate your development quickly, flexibly and
                efficiently. We can help you to get the right people on board.
                <br />
                Together we make sure you get your product development set up
                with the best chances for success!
              </p>
              <p>Just contact us now for a chat to find out if and where we can help you.</p>

              <ul className="actions">
                <li>
                  <Link to="#contact" className="button next">
                    Get in touch
                  </Link>
                </li>
              </ul>
            </div>
          </section>
          <section id="tech">
            <div className="inner">
              <header className="major">
                <h2>Technologies, Tools and Processes</h2>
              </header>
              <p>
                This is a selection of the techologies, tools and processes Dany Wyss
                and his team use and have used:
              </p>
              <div>
                <TechCloud />
              </div>
              <p>
                We believe these are just a means to an end - adapting the right
                tools means continually learning and evolving.
              </p>
              <p>If you want to know what else we master, just ask.</p>
              <ul className="actions">
                <li>
                  <Link to="#contact" className="button next">
                    Get in touch
                  </Link>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </Layout>
    )
  }
}

export default HomeIndex
